import React, { useEffect, useRef, useState } from "react";

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import ChangeCreditLimitModal from "../LimitLevels/ChangeCreditLimitModal";
import ChangeLevelModal from "../LimitLevels/ChangeLevelModal";

import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";

import MetasDashboardTable from "./MetasDashboardTable";

export default function MetasDashboard() {
  const createAsociadosRef = useRef();
  const changeCreditLimitRef = useRef();
  const changeLevelRef = useRef();

  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const [modalData, setModalData] = useState(null);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  /** FILTERS */

  useEffect(() => {
    console.log("--->");

    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,

        minYear: 2020,
        maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)
        ranges: {
          Hoy: [now, now],
          Ayer: [yesterday, yesterday],
          "Ultimos 7 Dias": [daysBack7, now],
          "Ultimos 30 Dias": [daysBack30, now],
          "Este mes": [thisMonthStart, thisMonthEnd],
          "Ultimo mes": [lastMonthStart, lastMonthEnd],
          "Ultimo Año": [lastYearStart, lastYearEnd],
        },
      },
      function (start, end, label) {
        //  alert("You are " + years + " years old!");
      }
    );

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);

  const fetchData = async () => {};

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createAsociadosRef);
    setModalData(item);

    createAsociadosRef.current.toggleModal();
  }

  return (
    <>
      <div className="">
        <div className="bd-example">
          <div className="container  overflow-hidden">
            <div className="row  gx-5">
              <div
                className="col card1 recent-sales overflow-auto"
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "0px",
                  marginBottom: "30px",
                }}
              ></div>

              <div
                className="col card1 recent-sales overflow-auto"
                style={{
                  backgroundColor: "transparent",
                  borderRadius: "0px",
                  marginBottom: "30px",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div className="card recent-sales overflow-auto">
        <ChangeCreditLimitModal ref={changeCreditLimitRef} item={modalData} />

        <ChangeLevelModal ref={changeLevelRef} item={modalData} />

        <div className="separator"></div>
        <div className="">
          <div
            className="container-fluid"
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          ></div>
        </div>

        <div className="card-body">
          <MetasDashboardTable openItem={loadItem} />
        </div>
      </div>
    </>
  );
}
